import React, { FunctionComponent, useLayoutEffect, useRef, useState } from 'react'
import styles from './QuoteElement.module.sass'
import clsx from 'clsx'
import { Classes } from '../../../../styles'
import { Comment } from '../../../../responses/comments'
import Button from '../../../controls/Button/Button'
import CloseIcon from 'files/close.svg'
import { processDate } from '../../../../utils/date-utils'
import Html from '../../../etc/Html/Html'
import Album from '../../files/Album/Album'
import { Link } from 'react-router-dom'
import { urlWithParams, urlWithQuery } from '../../../../http/utils'
import { pipe } from 'fp-ts/es6/function'
import { ROUTES } from '../../../../http/routes'
import { useRootDispatch } from '../../../../utils/hooks'
import { push } from 'connected-react-router'
import { FileData } from '../../../../responses/files'
import Ellipsis from '../../../etc/Ellipsis/Ellipsis'

interface Props {
    className?: string,
    comment: Comment
    onDelete?: () => void,
    onImageClick?: (file: FileData) => void,
}

const QuoteElement: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()
    const textRef = useRef<HTMLDivElement>(null)
    const [overflow, setOverflow] = useState(false)
    useLayoutEffect(() => {
        setOverflow((textRef.current?.scrollHeight ?? 0) > (textRef.current?.clientHeight ?? 0))
    }, [props.comment.text])

    const url = pipe(
        ROUTES.TASK,
        urlWithParams({ taskId: props.comment.owner_id }),
        urlWithQuery({ comment: props.comment.id })
    )
    return <Link className={clsx(styles.quote, props.className)} to={url}>
        <div className={styles.header}>
            <span className={clsx(Classes.cGrey, Classes.f9)}>{processDate(props.comment.created_at)}</span>
            <Ellipsis className={Classes.f13b}>{props.comment.user?.name}</Ellipsis>
        </div>
        <div className={styles.content}>
            <Html ref={textRef} className={clsx(styles.text, {[styles.overflow]: overflow})} html={props.comment.text}/>
            <Album files={props.comment.files} onClick={file => {
                if (props.onImageClick) {
                    props.onImageClick(file)
                } else {
                    dispatch(push(url))
                }
            }}/>
        </div>
        {
            props.onDelete && <Button onClick={event => {
                event.preventDefault()
                props.onDelete?.()
            }}><CloseIcon/></Button>
        }
    </Link>
}

export default QuoteElement